import React from 'react';

export const TimelyzerMark = ({ className = 'h-9 w-9', inverse = false, title = 'Timelyzer' }) => (
  <svg
    viewBox="0 0 48 48"
    className={className}
    role="img"
    aria-label={title}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="11" fill={inverse ? '#3D8163' : '#246B52'} />
    <path
      d="M13 14C19 14 20 24 27 24"
      stroke="#C4E1D2"
      strokeWidth="2.75"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M13 24H36"
      stroke="#FFFFFF"
      strokeWidth="2.75"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M13 34C19 34 20 24 27 24"
      stroke="#C4E1D2"
      strokeWidth="2.75"
      strokeLinecap="round"
      fill="none"
    />
    <path d="M33 19L38 24L33 29" stroke="#FFFFFF" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="10" cy="14" r="2.75" fill="#9FCBB5" />
    <circle cx="10" cy="24" r="2.75" fill="#FFFFFF" />
    <circle cx="10" cy="34" r="2.75" fill="#F1C96F" />
  </svg>
);

const TimelyzerLogo = ({
  className = '',
  descriptor,
  inverse = false,
  markClassName = 'h-9 w-9',
  wordmarkClassName = '',
}) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <TimelyzerMark className={markClassName} inverse={inverse} />
    <span>
      <span
        className={`block text-lg font-bold leading-none ${inverse ? 'text-white' : 'text-[#17211c]'} ${wordmarkClassName}`}
      >
        Timelyzer
      </span>
      {descriptor && (
        <span
          className={`mt-1 block text-[10px] font-bold uppercase ${
            inverse ? 'text-[#9BC8B2]' : 'text-[#7A857E]'
          }`}
        >
          {descriptor}
        </span>
      )}
    </span>
  </span>
);

export default TimelyzerLogo;
